import React from 'react';
import classNames from "classnames";
import "./device-battery-status.scss";
import Battery from '../../../../data/BatteryStatus';
import BatteryStatus from "../../../../data/BatteryStatus";
import BatteryBars25, { BatteryBars0, BatteryBars100, BatteryBars50, BatteryBars75 } from "../BatteryIcons/BatteryBars";
export default function DeviceBatteryStatus(props) {
    // if (props.device.fourBarBatterySample === Battery.NONE) {
    //     return <BatteryBars0/> ;
    // }
    var battery = React.createElement(BatteryBars0, null);
    switch (props.device.fourBarBatterySample) {
        case BatteryStatus.LOW:
            battery = React.createElement(BatteryBars25, null);
            break;
        case BatteryStatus.MEDIUM:
            battery = React.createElement(BatteryBars50, null);
            break;
        case BatteryStatus.HIGH:
            battery = React.createElement(BatteryBars75, null);
            break;
        case BatteryStatus.FULL:
            battery = React.createElement(BatteryBars100, null);
            break;
    }
    var classes = classNames({
        'device-battery-status--compact': props.compact,
        'device-battery-status--0': props.device.fourBarBatterySample === Battery.LOW,
        'device-battery-status--25': props.device.fourBarBatterySample === Battery.MEDIUM,
        'device-battery-status--50': props.device.fourBarBatterySample === Battery.HIGH,
        'device-battery-status--75': props.device.fourBarBatterySample === Battery.FULL,
        'device-battery-status--success': props.device.fourBarBatterySample === Battery.HIGH || props.device.fourBarBatterySample === Battery.FULL,
        'device-battery-status--warning': props.device.fourBarBatterySample === Battery.MEDIUM,
        'device-battery-status--danger': props.device.fourBarBatterySample === Battery.LOW
    });
    return React.createElement("div", { className: 'device-battery-status d-flex align-items-center ' + classes },
        React.createElement("div", { className: "device-battery-status__indicator mr-3" }),
        battery,
        props.device.batteryRemainingPctValue ? props.device.batteryRemainingPctValue + '%' : '?');
}
